import { render, staticRenderFns } from "./BalanceChangeDetails.vue?vue&type=template&id=6ab9f858&scoped=true"
import script from "./BalanceChangeDetails.vue?vue&type=script&lang=js"
export * from "./BalanceChangeDetails.vue?vue&type=script&lang=js"
import style0 from "./BalanceChangeDetails.vue?vue&type=style&index=0&id=6ab9f858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab9f858",
  null
  
)

export default component.exports